import { useEffect } from 'react';

type HeadProps = {
  children: React.ReactNode;
};

export default function Head({ children }: HeadProps) {
  useEffect(() => {
    const titles: string[] = [];
    const visit = (node: React.ReactNode): void => {
      if (!node) {
        return;
      }
      if (Array.isArray(node)) {
        node.forEach(visit);
        return;
      }
      if (typeof node === 'object' && node !== null && 'type' in node) {
        const el = node as { type?: unknown; props?: { children?: React.ReactNode } };
        if (el.type === 'title' && el.props?.children) {
          titles.push(String(el.props.children));
        }
        visit(el.props?.children);
      }
    };
    visit(children);
    if (titles.length > 0) {
      document.title = titles.join('');
    }
  }, [children]);

  return null;
}
